export default {

    //是否存在指定函数
    isExitsFunction(funcName) {
        try {
            return typeof(eval(funcName)) === "function";
        } catch(e) {}

        return false;
    },

    //是否存在指定变量
    isExitsVariable(variableName) {
        try {
            return typeof(eval(variableName)) !== "undefined";
        } catch(e) {}

        return false;
    },

    uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    pattern: {
        // 邮件
        email: /^\+?[a-z0-9](([-+.]|[_]+)?[a-z0-9]+)*@([a-z0-9]+(\.|\-))+[a-z]{2,6}$/,
        // 密码; 1 可以全数字，2 可以全字母，3 可以全特殊字符(~!@#$%^&*.)，4 三种的组合，5 可以是任意两种的组合，6 长度6-22
        pass: /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{6,22}$/,
        // 验证码
        sms: /^\d{4}$/,
        // 公司名称
        companyName: /^[\(\)\（\）\u4E00-\u9FA5]+$/,
        // 信用代码
        uscc: /^[1-9A-GY]{1}[1239]{1}[1-5]{1}[0-9]{5}[0-9A-Z]{10}$/,
        // 身份证
        card: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        // 手机号（支持手机号码，3-4位区号，7-8位直播号码，1－4位分机号）
        phone: /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
        // 全数字
        number: /^[0-9]*$/,
        // 数字或小数
        number2: /^[0-9]+\.{0,1}[0-9]{0,2}$/,
        // 用户名
        regName: /^[a-zA-z][a-zA-Z0-9_]{3,16}$/,
        // 手机号
        mobile: /^1[23456789]\d{9}$/
    },
}
